import React, { useEffect, useState } from 'react'
import {
    Col,
    Row,
    Input,
    Form,
    Button,
    Space,
    DatePicker,
    type DatePickerProps,
    TimePicker,
    Select,
    Radio,
    Checkbox,
    type RadioChangeEvent,
    Tooltip,
    type RadioGroupProps,
    Skeleton,
} from 'antd'
import commonStyles from '../../../Utils/Common.less'
import { SaveOutlined } from '@ant-design/icons'
import { connect, useDispatch } from 'react-redux'
import dayjs, { type Dayjs } from 'dayjs'
import {
    type statustPropety,
    type changeProcessModelprops,
    type changeProcessModelProps,
    type PinedMessage,
    type ServiceActionGetNextStatusData,
} from '../../../Types/ToDoViewAllList'
import {
    GetNextStatus,
    GetPinnedChat,
    GetServiceProcessInduvidual,
    SaveChangePrgress,
} from '../../../Services/ToDoViewAllList'
import { type ListFrontEndInterface } from '../../../Types/CommonType'
import {
    GetChangesStatusDropDownList,
    GetChFillingDropDownList,
    GetRecordChangesDropDownList,
} from '../../../Services/Common'
import S3Upload from '../../../Components/S3Upload'
import { getClientCompanyContactDetails } from '../../../Services/Corporate'
import CustomQuill from '../../../Components/CustomQuill'
interface ProcessRemarkProps extends changeProcessModelprops {
    auditdata?: PinedMessage | null
    serviceId: number
    chfillingList: ListFrontEndInterface[]
    actionStatusId: number
    serviceActionGetNextStatusData: ServiceActionGetNextStatusData
    setResetData: React.Dispatch<React.SetStateAction<string>>
    restData: string
    typeId: number
    isLoading: boolean
    changeStatusList: ListFrontEndInterface[]
    recodeChangeList: ListFrontEndInterface[]
}
const ChangeProgressModel = (props: ProcessRemarkProps): React.ReactElement => {
    const {
        serviceProcessId,
        serviceActionId,
        changeModelState,
        actionStatusId,
        serviceActionGetNextStatusData,
        setResetData,
        restData,
        typeId,
        changeStatusList,
        recodeChangeList,
        serviceProcessInduvidualData,
        serviceId,
    } = props
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [selectedDate, setSelectedDate] = useState<Record<number, string>>({})
    const [hourValue, setHourValue] = useState<Dayjs | null>(null)
    const [minuteValue, setMinuteValue] = useState<Dayjs | null>(null)
    const [emailText, setEmailText] = useState('')
    const [buttonLoading, setButtonloading] = useState(false)
    const [chFillingListData, setChfillingListData] = useState('')
    const [value2, setValue2] = useState('0')
    const [DDLvalue, setDDLvalue] = useState(0)
    const [loading, setLoading] = useState(false)
    const onChangeHour = (time: Dayjs, timeString: string | string[]): void => {
        setHourValue(time)
        void form.validateFields(['workdhours'])
    }
    const optionsWithDisabled: RadioGroupProps['options'] =
        serviceId === 10
            ? [
                  { label: 'Email', value: '1' },
                  { label: 'SMS', value: '2' },
                  { label: 'Phone', value: '3' },
                  { label: 'Iykons', value: '4' },
              ]
            : [
                  { label: 'Email', value: '1' },
                  { label: 'SMS', value: '2' },
                  { label: 'Phone', value: '3' },
              ]
    const [checkValue, setCheckValue] = useState(0)
    const audit =
        '<p><span style="color: rgb(33, 37, 41);letter-spacing: 0.1px;font-size: 14px;"><b><u>1.Assumptions</u></b></span></p><p><br></></p><p><span style="color: rgb(33, 37, 41);letter-spacing: 0.1px;font-size: 14px;"><b><u>2.Recommendation</u></b></span></p><p><br></></p><p><span style="color: rgb(33, 37, 41);letter-spacing: 0.1px;font-size: 14px;"><b><u>3.Actions to be taken</u></b></span></p><p><br></></p>'

    useEffect(() => {
        if (restData === 'true') {
            setHourValue(null)
            setMinuteValue(null)
            form.resetFields()
            form.setFieldsValue({
                CompleteComments: '',
                historyDate: '',
            })

            setSelectedDate('')
        }
        setResetData('false')
    }, [restData])
    useEffect(() => {
        setLoading(true)
        const timer = setTimeout(() => {
            void fetchAuditData()
            GetServiceProcessInduvidual(dispatch, serviceProcessId)
            GetChFillingDropDownList(dispatch)
            GetRecordChangesDropDownList(dispatch)
            GetChangesStatusDropDownList(dispatch)
            if (
                serviceProcessId !== undefined &&
                serviceProcessId !== null &&
                serviceActionId !== null &&
                actionStatusId !== 0
            ) {
                GetNextStatus(
                    dispatch,
                    serviceProcessId,
                    typeId,
                    actionStatusId,
                    serviceActionId,
                    setLoading
                )
            }
        }, 300)

        return () => {
            clearTimeout(timer)
        }
    }, [serviceProcessId, serviceActionId, actionStatusId, restData])
    const fetchAuditData = async (): Promise<void> => {
        try {
            const data = await GetPinnedChat(dispatch, serviceProcessId)
            if (data?.description?.length !== 0) {
                form.setFieldValue('summernote', data?.description)
                setEmailText(data?.description)
            } else {
                form.setFieldValue('summernote', audit)
                setEmailText(audit)
            }
        } catch (error) {
            console.error('Error fetching audit data:', error)
        }
    }

    const onChangeMinute = (
        time: Dayjs,
        timeString: string | string[]
    ): void => {
        setMinuteValue(time)
        void form.validateFields(['workdhours'])
    }

    const setFormData = (name: string, location: string): void => {
        form.setFieldValue(name, location)
    }
    const onChange = (
        dateOfBirth: DatePickerProps['value'],
        dateString: string | string[],
        propertyId: number
    ): void => {
        if (dateOfBirth !== null && dateOfBirth !== undefined) {
            const isoDate = dayjs(dateOfBirth).toISOString()
            setSelectedDate((prev) => ({
                ...prev,
                [propertyId]: isoDate,
            }))
            form.setFieldValue(['dateFields', propertyId], isoDate)
            void form.validateFields([['dateFields', propertyId]])
        } else {
            form.setFieldValue(['dateFields', propertyId], null)
        }
    }

    const chfillingOnchange = (value: string[]): void => {
        const result = `${value?.join(',')}`
        setChfillingListData(result)
    }
    const onChange2 = ({ target: { value } }: RadioChangeEvent): void => {
        setValue2(value)
    }
    const onSave = (): void => {
        void onSavePhone()
    }

    const onSavePhone = async (): Promise<void> => {
        try {
            await form.validateFields()
            setButtonloading(true)
            const formData = form.getFieldsValue()

            const serviceProcessStatusProperty: statustPropety[] = []
            serviceActionGetNextStatusData?.serviceActionProperty?.forEach(
                (item) => {
                    switch (item.propertyDataType.toLowerCase()) {
                        case 'file':
                            if (
                                formData.FileUpload !== undefined &&
                                formData.FileUpload !== null
                            )
                                serviceProcessStatusProperty.push({
                                    propertyType: item.propertyType,
                                    referenceId: item.propertyId,
                                    propertyValue: formData.FileUpload ?? '',
                                    propertyDataType: 'file',
                                })
                            break
                        case 'duration':
                            if (serviceId !== 10) {
                                if (
                                    hourValue !== null &&
                                    minuteValue !== null
                                ) {
                                    const hour = parseInt(
                                        hourValue.format('HH')
                                    )
                                    const minute = parseInt(
                                        minuteValue.format('mm')
                                    )
                                    const duration = hour * 60 + minute
                                    serviceProcessStatusProperty.push({
                                        propertyType: item.propertyType,
                                        referenceId: item.propertyId,
                                        propertyValue: duration.toString(),
                                        propertyDataType: 'duration',
                                    })
                                } else if (
                                    hourValue === null &&
                                    minuteValue !== null
                                ) {
                                    const minute = parseInt(
                                        minuteValue.format('mm')
                                    )
                                    const duration = minute
                                    serviceProcessStatusProperty.push({
                                        propertyType: item.propertyType,
                                        referenceId: item.propertyId,
                                        propertyValue: duration.toString(),
                                        propertyDataType: 'duration',
                                    })
                                } else if (
                                    hourValue !== null &&
                                    minuteValue === null
                                ) {
                                    const hour = parseInt(
                                        hourValue.format('HH')
                                    )

                                    const duration = hour * 60
                                    serviceProcessStatusProperty.push({
                                        propertyType: item.propertyType,
                                        referenceId: item.propertyId,
                                        propertyValue: duration.toString(),
                                        propertyDataType: 'duration',
                                    })
                                }
                            }
                            break
                        case 'text':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: formData.text,
                                propertyDataType: 'text',
                            })
                            break
                        case 'currency':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: formData.currency,
                                propertyDataType: 'currency',
                            })
                            break
                        case 'number':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: formData.number,
                                propertyDataType: 'number',
                            })
                            break

                        case 'date':
                            if (selectedDate !== null) {
                                serviceProcessStatusProperty.push({
                                    propertyType: item.propertyType,
                                    referenceId: item.propertyId,
                                    propertyValue: dayjs(
                                        selectedDate[item.propertyId]
                                    ).format('DD/MM/YYYY'),
                                    propertyDataType: 'date',
                                })
                            }
                            break

                        case 'time':
                            if (hourValue !== null && minuteValue !== null) {
                                const hour = parseInt(hourValue.format('HH'))
                                const minute = parseInt(
                                    minuteValue.format('mm')
                                )
                                const duration = hour * 60 + minute
                                serviceProcessStatusProperty.push({
                                    propertyType: item.propertyType,
                                    referenceId: item.propertyId,
                                    propertyValue: duration.toString(),
                                    propertyDataType: 'time',
                                })
                            } else if (
                                hourValue === null &&
                                minuteValue !== null
                            ) {
                                const minute = parseInt(
                                    minuteValue.format('mm')
                                )
                                const duration = minute
                                serviceProcessStatusProperty.push({
                                    propertyType: item.propertyType,
                                    referenceId: item.propertyId,
                                    propertyValue: duration.toString(),
                                    propertyDataType: 'time',
                                })
                            } else if (
                                hourValue !== null &&
                                minuteValue === null
                            ) {
                                const hour = parseInt(hourValue.format('HH'))

                                const duration = hour * 60
                                serviceProcessStatusProperty.push({
                                    propertyType: item.propertyType,
                                    referenceId: item.propertyId,
                                    propertyValue: duration.toString(),
                                    propertyDataType: 'time',
                                })
                            }
                            break
                        case 'com':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: value2,
                                propertyDataType: 'com',
                            })
                            break
                        case 'com-e':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: value2,
                                propertyDataType: 'com-e',
                            })
                            break
                        case 'com-s':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: value2,
                                propertyDataType: 'com-s',
                            })
                            break
                        case 'com-p':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: value2,
                                propertyDataType: 'com-p',
                            })
                            break
                        case 'onoff':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: checkValue.toString(),
                                propertyDataType: 'onoff',
                            })
                            break
                        case 'ddlms':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: chFillingListData,
                                propertyDataType: 'ddlms',
                            })
                            break
                        case 'ddl':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: DDLvalue.toString(),
                                propertyDataType: 'ddl',
                            })
                            break
                        case 'textarea':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: formData.textarea,
                                propertyDataType: 'textarea',
                            })
                            break
                        case 'summernote':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: emailText,
                                propertyDataType: 'summernote',
                            })
                            break
                        case 'hidden':
                            serviceProcessStatusProperty.push({
                                propertyType: item.propertyType,
                                referenceId: item.propertyId,
                                propertyValue: '',
                                propertyDataType: 'hidden',
                            })
                            break
                    }
                }
            )

            const dataToSave = {
                type: typeId,
                referenceId: serviceActionId ?? 0,
                statusId: serviceActionGetNextStatusData.actionStatusId,
                remarks: formData.CompleteComments ?? '',
                completeFlag: serviceActionGetNextStatusData.actionComplete,
                serviceProcessId,
                emailTemplateId: serviceActionGetNextStatusData.emailTemplateId,
                serviceProcessStatusProperty:
                    serviceProcessStatusProperty ?? [],
            }
            await SaveChangePrgress(dispatch, dataToSave)
                .then((result) => {
                    if (result !== null && result !== undefined) {
                        setButtonloading(false)
                        setHourValue(null)
                        setMinuteValue(null)
                        form.resetFields()
                        form.setFieldsValue({
                            CompleteComments: '',
                            historyDate: '',
                        })

                        changeModelState()
                    }
                })
                .catch(() => {})
        } catch (error) {}
    }

    const onCheckChange = (checked: boolean, id: number): void => {
        setCheckValue(checked ? 1 : 0)
        form.setFieldValue(['checkboxFields', id], checked)
        void form.validateFields([['checkboxFields', id]])
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    const validateWorkedHours = async (
        _: any,
        value: any
    ): Promise<undefined> => {
        if (hourValue !== null && minuteValue !== null) {
            await Promise.resolve()
            return
        }
        await Promise.reject(new Error('Please input worked Hours!'))
    }

    const changeDropDown = (value: number): void => {
        setDDLvalue(value)
    }

    useEffect(() => {
        if (serviceActionId === 96 && typeId === 1) {
            if (DDLvalue === 2) {
                void viewBusinessDetailsInNewTab(
                    serviceProcessInduvidualData.businessTypeId,
                    serviceProcessInduvidualData.referenceId
                )
            }
        }
    }, [serviceActionId, typeId, DDLvalue, serviceProcessInduvidualData])

    const viewBusinessDetailsInNewTab = async (
        businessTypeId: number,
        referenceId: number
    ): Promise<void> => {
        localStorage.removeItem('corporateData')
        localStorage.removeItem('onbordingId')

        const Data = await getClientCompanyContactDetails(
            dispatch,
            businessTypeId,
            referenceId,
            1
        )
        const corporateData = {
            clienttypeid: Data?.data?.initialDetails?.clienttypeid ?? 1,
            clienttype: Data?.data?.initialDetails?.clienttype,
            corporateid: Data?.data?.initialDetails?.corporateid,
            companyname: Data?.data?.initialDetails.companyname,
            clientnumber: Data?.data?.initialDetails.clientnumber,
            companyregisternumber: Data?.data?.initialDetails.companyregnumber,
        }

        const onbordingId = 1

        localStorage.setItem('corporateData', JSON.stringify(corporateData))
        localStorage.setItem('onbordingId', onbordingId.toString())

        // // Determine route based on business type SoleTraderData
        // const SoleTraderData = {
        //     soleTraderId: Data?.data?.soleTraderInitialDetails?.soleTraderId,
        //     businessTradingName:
        //         Data?.data?.soleTraderInitialDetails?.businessTradingName,
        //     clientNumber: Data?.data?.soleTraderInitialDetails?.clientNumber,
        // }
        // localStorage.setItem('SoleTraderData', JSON.stringify(SoleTraderData))
        // const individualData = {
        //     individualId: clientDashbordList?.referenceId,
        //     tradingName: clientDashbordList?.clientName,
        //     clientNumber: clientDashbordList?.clientNumber,
        //     activestatus: clientDashbordList?.companyStatus,
        //     emailAddress: clientDashbordList?.emailAddress,
        //     name: clientDashbordList?.contactName,
        //     mobilenumber: clientDashbordList?.contactNumber,
        //     alternativeEmailAddress: clientDashbordList?.altEmailAddress,
        // }
        // const partnershipData = {
        //     partnershipId: clientDashbordList?.referenceId,
        //     tradingName: clientDashbordList?.clientName,
        //     clientNumber: clientDashbordList?.clientNumber,
        //     activestatus: clientDashbordList?.companyStatus,
        //     emailAddress: clientDashbordList?.emailAddress,
        //     name: clientDashbordList?.contactName,
        //     mobilenumber: clientDashbordList?.contactNumber,
        //     alternativeEmailAddress: clientDashbordList?.altEmailAddress,
        //     serviceIds: clientDashbordList?.serviceList,
        //     partnershipUTR: clientDashbordList?.additionalDataOne,
        // }
        let path = ''
        switch (businessTypeId) {
            case 1:
                path = '/clients/registered-clients/corporate-view'
                break
            // case 2:
            //     path = '/clients/registered-clients/soletrader-view'
            //     break
            // case 3:
            //     path = '/clients/registered-clients/individual-view'
            //     break
            // case 4:
            //     path = '/clients/registered-clients/partnership-view'
            //     break
            default:
                return
        }

        // Open new tab with full URL
        const origin = window.location.origin
        const fullUrl = `${origin}${path}`
        window.open(fullUrl, '_blank')
    }

    const formElements: JSX.Element[] = []

    serviceActionGetNextStatusData?.serviceActionProperty?.forEach((item) => {
        const isRequired = item.isRequired === 1

        switch (item.propertyDataType.toLowerCase()) {
            case 'file':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={`${item.propertyName}`}
                            name="FileUpload"
                            required={isRequired}
                        >
                            <S3Upload
                                name={'FileUpload'}
                                value={form.getFieldValue('FileUpload')}
                                setFormData={setFormData}
                                corporate={''}
                                corporateid={0}
                                documenttype={''}
                                documentbaseId={0}
                                memberpersonId={0}
                            />
                        </Form.Item>
                    </Col>
                )
                break

            case 'text':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={item.propertyName}
                            name={`text`}
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: 'This field is required',
                                          },
                                      ]
                                    : []
                            }
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                )
                break

            case 'currency':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={item.propertyName}
                            name={`currency`}
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: 'This field is required',
                                          },
                                      ]
                                    : []
                            }
                        >
                            <Input type="number" min={0} placeholder="0.00" />
                        </Form.Item>
                    </Col>
                )
                break
            case 'number':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={item.propertyName}
                            name={`number`}
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: 'This field is required',
                                          },
                                      ]
                                    : []
                            }
                        >
                            <Input type="number" min={0} placeholder="0.00" />
                        </Form.Item>
                    </Col>
                )
                break

            case 'date':
                if (serviceId === 10 && item.propertyId !== 2432) {
                    formElements.push(
                        <Col span={12} key={item.propertyId}>
                            <Form.Item
                                label={item.propertyName}
                                name={['dateFields', item.propertyId]} // use nested structure to keep clean
                                rules={[
                                    ...(item.isRequired !== 0
                                        ? [
                                              {
                                                  required: true,
                                                  message: `Please select ${item.propertyName}!`,
                                              },
                                          ]
                                        : []),
                                ]}
                            >
                                <Space direction="vertical" size={12} wrap>
                                    <DatePicker
                                        onChange={(date, dateString) => {
                                            onChange(
                                                date,
                                                dateString,
                                                item.propertyId
                                            )
                                        }}
                                        value={
                                            selectedDate[item.propertyId]
                                                ?.length > 0
                                                ? dayjs(
                                                      selectedDate[
                                                          item.propertyId
                                                      ]
                                                  )
                                                : null
                                        }
                                        format="DD/MM/YYYY"
                                        className={commonStyles.dateWidth}
                                        allowClear
                                        disabledDate={(current) =>
                                            current !== null &&
                                            current > dayjs().endOf('day')
                                        } // disable future dates
                                    />
                                </Space>
                            </Form.Item>
                        </Col>
                    )
                }
                break

            case 'time':
                formElements.push(
                    <div key={item.propertyId}>
                        <Col span={12}>
                            <Form.Item
                                label={`${item.propertyName}`}
                                name="time"
                                rules={[
                                    {
                                        required: isRequired,
                                        validator: validateWorkedHours,
                                    },
                                ]}
                            >
                                <Row>
                                    <Space wrap>
                                        <Col span={24}>
                                            <TimePicker
                                                value={hourValue}
                                                onChange={(
                                                    time,
                                                    timestring
                                                ) => {
                                                    onChangeHour(
                                                        time,
                                                        timestring
                                                    )
                                                }}
                                                format="HH"
                                                showHour
                                                size={'middle'}
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <TimePicker
                                                value={minuteValue}
                                                onChange={(
                                                    time,
                                                    timestring
                                                ) => {
                                                    onChangeMinute(
                                                        time,
                                                        timestring
                                                    )
                                                }}
                                                format="mm"
                                                showMinute
                                                size={'middle'}
                                            />
                                        </Col>
                                    </Space>
                                </Row>
                            </Form.Item>
                        </Col>
                        )
                    </div>
                )
                break
            case 'com':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={`${item.propertyName}`}
                            name="com"
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: `Please  Select ${item.propertyName}!`,
                                          },
                                      ]
                                    : []
                            }
                            initialValue={'1'}
                        >
                            <Radio.Group
                                onChange={onChange2}
                                value={value2}
                                defaultValue={'1'}
                            >
                                {(
                                    optionsWithDisabled as Array<{
                                        label: string
                                        value: string
                                    }>
                                ).map((option) => (
                                    <Radio
                                        key={option.value}
                                        value={option.value}
                                    >
                                        {option.label}

                                        {serviceId === 10 &&
                                            option.label === 'Phone' && (
                                                <span style={{ marginLeft: 8 }}>
                                                    {' '}
                                                    OR
                                                </span>
                                            )}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                )
                break
            case 'com-e':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={`${item.propertyName}`}
                            name="com-e"
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: `Please  Select ${item.propertyName}!`,
                                          },
                                      ]
                                    : []
                            }
                            initialValue={'1'}
                        >
                            <Radio.Group
                                defaultValue={'1'}
                                options={optionsWithDisabled}
                                onChange={onChange2}
                                value={value2}
                            />
                        </Form.Item>
                    </Col>
                )
                break
            case 'com-s':
                formElements.push(
                    <Col>
                        <Form.Item
                            label={`${item.propertyName}`}
                            name="com-s "
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: `Please  Select ${item.propertyName}!`,
                                          },
                                      ]
                                    : []
                            }
                            initialValue={'1'}
                        >
                            <Radio.Group
                                defaultValue={'1'}
                                options={optionsWithDisabled}
                                onChange={onChange2}
                                value={value2}
                            />
                        </Form.Item>
                    </Col>
                )
                break
            case 'com-p':
                formElements.push(
                    <Col>
                        <Form.Item
                            label={`${item.propertyName}`}
                            name="com-p"
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: `Please  Select ${item.propertyName}!`,
                                          },
                                      ]
                                    : []
                            }
                            initialValue={'1'}
                        >
                            <Radio.Group
                                options={optionsWithDisabled}
                                onChange={onChange2}
                                value={value2}
                            />
                        </Form.Item>
                    </Col>
                )
                break
            case 'onoff':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={`${item.propertyName}`}
                            name={['checkboxFields', item.propertyId]} // Dynamic field path
                            valuePropName="checked"
                            initialValue={false}
                        >
                            <Checkbox
                                onChange={(e) => {
                                    onCheckChange(
                                        e.target.checked,
                                        item.propertyId
                                    )
                                }}
                            >
                                {item.propertyDescription}
                            </Checkbox>
                        </Form.Item>
                    </Col>
                )
                break
            case 'duration':
                if (serviceId !== 10) {
                    formElements.push(
                        <Col span={12}>
                            <Form.Item
                                label={`${item.propertyName}`}
                                name="workdhours"
                                rules={[
                                    {
                                        required: true,
                                        validator: validateWorkedHours,
                                    },
                                ]}
                            >
                                <Row>
                                    <Space wrap>
                                        <Col span={24}>
                                            <TimePicker
                                                value={hourValue}
                                                onChange={(
                                                    time,
                                                    timestring
                                                ) => {
                                                    onChangeHour(
                                                        time,
                                                        timestring
                                                    )
                                                }}
                                                format="HH"
                                                showHour
                                                size={'middle'}
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <TimePicker
                                                value={minuteValue}
                                                onChange={(
                                                    time,
                                                    timestring
                                                ) => {
                                                    onChangeMinute(
                                                        time,
                                                        timestring
                                                    )
                                                }}
                                                format="mm"
                                                showMinute
                                                size={'middle'}
                                            />
                                        </Col>
                                    </Space>
                                </Row>
                            </Form.Item>
                        </Col>
                    )
                }
                break
            case 'ddlms':
                formElements.push(
                    <Col span={24}>
                        {DDLvalue === 2 && (
                            <Form.Item
                                label={`${item.propertyName}`}
                                name="ddlms"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select CH Filing!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Please Select"
                                    allowClear
                                    mode={'multiple'}
                                    onChange={(value) => {
                                        chfillingOnchange(value)
                                    }}
                                    filterOption={(input, option) =>
                                        !(option == null) &&
                                        option.label
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    options={recodeChangeList?.map(
                                        (country) => ({
                                            value: country.label,
                                            label: country.label,
                                        })
                                    )}
                                />
                            </Form.Item>
                        )}
                    </Col>
                )
                break
            case 'ddl':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={`${item.propertyName}`}
                            name="ddl"
                            rules={[
                                {
                                    required: true,
                                    message: `Please select ${item.propertyName}`,
                                },
                            ]}
                        >
                            <Select
                                placeholder="Please Select"
                                allowClear
                                onChange={(value) => {
                                    changeDropDown(value)
                                }}
                                filterOption={(input, option) =>
                                    !(option == null) &&
                                    option.label
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                options={changeStatusList}
                            />
                        </Form.Item>
                    </Col>
                )
                break
            case 'textarea':
                formElements.push(
                    <div key={item.propertyId}>
                        <Col span={24}></Col>
                        <Form.Item
                            label={item.propertyName}
                            name={`textarea`}
                            rules={
                                isRequired
                                    ? [
                                          {
                                              required: true,
                                              message: 'This field is required',
                                          },
                                      ]
                                    : []
                            }
                        >
                            <Input.TextArea rows={4} />
                        </Form.Item>
                    </div>
                )
                break
            case 'summernote':
                formElements.push(
                    <Col span={24}>
                        <Form.Item
                            label={item.propertyName}
                            name="summernote"
                            rules={[
                                {
                                    required: true,
                                    message: `Please input ${item.propertyName} !`,
                                },
                            ]}
                        >
                            <CustomQuill
                                onDescriptionChange={(content) => {
                                    setEmailText(content)
                                }}
                                emailText={emailText ?? ''}
                            />
                        </Form.Item>
                    </Col>
                )
                break
            case 'hidden':
                formElements.push(
                    <Col span={24}>
                        <Form.Item>
                            <Input hidden={true} />
                        </Form.Item>
                    </Col>
                )
                break
            default:
                break
        }
    })
    return (
        <>
            <Skeleton loading={loading} active>
                <div>
                    <h3>{serviceActionGetNextStatusData?.actionStatus}</h3>
                    <h5>{serviceActionGetNextStatusData?.title}</h5>
                </div>
                <div className={commonStyles.formWrapper}>
                    <Form
                        name="complex-form221"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        initialValues={{ remember: true }}
                        layout={'vertical'}
                        autoComplete="off"
                        form={form}
                        requiredMark={customizeRequiredMark}
                    >
                        <Row gutter={16}>{formElements}</Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    label={`${serviceActionGetNextStatusData?.actionStatus?.split('-')[0] ?? 'Process'}-Remarks`}
                                    name="CompleteComments"
                                >
                                    <Input.TextArea rows={4} />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col offset={21} span={2}>
                                <Tooltip title="Update Progress Status">
                                    <Button
                                        type="primary"
                                        size="middle"
                                        onClick={onSave}
                                        loading={buttonLoading}
                                    >
                                        <SaveOutlined />
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Skeleton>
        </>
    )
}

const mapStateToProps = (state: any): changeProcessModelProps => {
    return {
        serviceProcessInduvidualData:
            state.dashboardInfo.serviceProcessInduvidualData,
        chfillingList: state.initial.chfillingList,
        serviceActionGetNextStatusData:
            state.dashboardInfo.serviceActionGetNextStatusData,
        isLoading: state.common.isLoading,
        changeStatusList: state.initial.changeStatusList,
        recodeChangeList: state.initial.recodeChangeList,
    }
}

export default connect(mapStateToProps)(ChangeProgressModel)
